// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"8c1a0435","452":"78b104a2","669":"9f46b955"}[chunkId] + ".chunk.js";
};